import React, { useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { fetchAlerts } from "../../api/alerts";
import { fetchBanners } from "../../api/banners";
import { fetchCatalogs } from "../../api/catalogs";
import { fetchFiles, fetchFaldonesByCategoryAndTienda } from "../../api/files";
import { fetchPromotions } from "../../api/promotions";
import { fetchSkirts } from "../../api/skirts";
import { findAlertDate, findAlertTitle } from "../../helpers";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import { StoreContext } from "../../store/StoreContext";
import _ from "lodash";
import { SMU_FILTER } from "../../constants";
import {
  MANUALS_CATEGORY,
  SKITRS_CATEGORY,
} from "../../constants/categories";

const brand = process.env.REACT_APP_BRAND || "UNI";

const Portal = () => {
  const {
    setAlerts,
    setPromotions,
    setTopPromotions,
    setManuals,
    setSkirts,
    setPdfForPreview,
    setTopManuals,
    setTopCatalogs,
    setTopSkirts,
    setBanners,
    isAdmin,
    loggedUser
  } = useContext(StoreContext);

  const handleFetchAlerts = async () => {
    const { data, error } = await fetchAlerts(brand);
    if (error) return;
    const _dataAlerts = data?.O_ALERTAS || [];
    const alerts = _.map(_dataAlerts, (alert, index) => {
      const date = findAlertDate(alert.ALERTA);
      const title = findAlertTitle(alert.ALERTA);
      return {
        id: index,
        start: _.get(date, 0, null),
        end: _.get(date, 1, null),
        title,
      };
    });
    setAlerts(alerts);
  };

  const handleCreateFilterObject = () => {
    // Check if the filter object already exists to prevent overwriting it
    if(localStorage.getItem(SMU_FILTER)) {
      return;
    }
    var filterObject = {
      tienda: "",
      ean: "",
      f_categoria: "",
      f_marca: "",
      f_producto:"",
      fecha_publicacion_desde: "",
      fecha_publicacion_hasta: "",
      fecha_inicio_desde: "",
      fecha_inicio_hasta: "",
      fecha_fin_desde: "",
      fecha_fin_hasta: "",
      formato_impresion: "",
      keyword: "",
      p_nombre_producto: "",
      p_seccion: "",
      p_linea: "",
      p_categoria: "",
      f_negocio: ""
    }
    localStorage.setItem(SMU_FILTER, JSON.stringify(filterObject));
  }

  const handleFetchPromotions = async () => {
    const { data, error } = await fetchPromotions(brand, 333);
    if (error) return;
    setPromotions(data);
  };

  const handleFetchTopPromotions = async () => {
    const { data, error } = await fetchPromotions(brand, 333, 5);
    if (error) return;
    setTopPromotions(data);
  };

  const handleFetchManuals = async () => {
    const { data, error } = await fetchFiles(MANUALS_CATEGORY);
    if (error) return;
    const manuals = data?.data?.documents || [];
    setManuals(manuals);
  };

  const handleFetchSkirts = async () => {
    const { data, error } = await fetchSkirts();
    if (error) return;
    // Using: data.menu.items - array of menu items
    // Each item properties used: id, parent, and all other properties (spread)
    // id is converted to Number
    // parent is converted to Number (or 0 if not present)
    const skirts = data?.menu?.items || [];
    const _dataSkirts = skirts.map((skirt) => ({
      ...skirt,
      id: Number(skirt.id),
      parent: skirt?.parent ? Number(skirt.parent) : 0,
    }));
    setSkirts(_dataSkirts);
  };

  const handleFetchCatalogs = async () => {
    const { data, error } = await fetchCatalogs();
    if (error) return;
    const catalogs = data?.data?.details || [];
    setTopCatalogs(catalogs.slice(0, 5));
    if (catalogs?.length > 0) setPdfForPreview(catalogs[0]);
  };

  const handleFetchTopManuals = async () => {
    const { data, error } = await fetchFiles(MANUALS_CATEGORY, 5);
    if (error) return;
    const topManuals = data?.data?.documents || [];
    setTopManuals(topManuals);
  };

  const handleFetchTopSkirts = async () => {
    if (loggedUser && loggedUser.username) {
      const username = loggedUser.username;
      const tienda = isAdmin ? null : (loggedUser && loggedUser.store ? loggedUser.store[0] : -1);
      try {
        const limit = 5;
        const { data, error } = await fetchFaldonesByCategoryAndTienda(tienda, username, null, null, null, null, null, null, null, null, null, null, null, null, limit);
        if (error) return;
        const faldones = (data || [])
          .filter((faldon, idx) => idx < 5 ) //|| !faldon.DOWNLOADED)
          .map(faldon => ({
          ...faldon,
          filename: faldon.FALDON_XLSX.replace(/\.(xlsx|xls)$/i, ''),
          id: faldon.FALDON_XLSX,
          views: faldon.VIEWS,
        }));
        setTopSkirts(faldones);
      } catch (err) {
        console.error("Error fetching top skirts:", err);
      }
    } else {
      console.warn("handleFetchTopSkirts: loggedUser not available yet");
    }
  };

  const handleFetchBanners = async () => {
    const { data, error } = await fetchBanners();
    if (error) return;
    const banners = data?.data?.documents || [];
    setBanners(banners);
  };

  useEffect(() => {
    handleFetchAlerts();
    handleFetchPromotions();
    handleFetchTopPromotions();
    handleFetchManuals();
    handleFetchSkirts();
    handleFetchCatalogs();
    handleFetchTopManuals();
    handleFetchTopSkirts();
    handleFetchBanners();
    handleCreateFilterObject();
  }, [loggedUser, isAdmin]);

  return <Outlet />;
};

export default Portal;
